module.exports = __webpack_public_path__ + "img/news3.0b5c84b8.jpg";